export default __webpack_public_path__ + "static/media/img6.42bc5526.webp";